import { memo } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";

import "./Total.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const Total = ({
	total,
	discountPercentage,
	isPagePayment = false,
	isLoading,
	taxesAndFeesIncluded = false,
}) => {
	return (
		<div className="total" data-testid="booking-total">
			<div className="total__label">
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} isBold component={"span"}>
					<FormattedMessage id="price.detail.total.label" />
				</Typography>
				{taxesAndFeesIncluded && (
					<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} component={"span"}>
						<div className="total__label--note">
							(<FormattedMessage id="general.all.taxes.and.fees.included.label" />)
						</div>
					</Typography>
				)}
			</div>
			<div className="total__value total__price-detail-item">
				{discountPercentage > 0 && (
					<Typography
						variant={TYPOGRAPHY_VARIANTS.SMALL}
						component="span"
						data-testid="total-discount-percentage"
						className="total__discount-percentage"
					>
						-{discountPercentage}%
					</Typography>
				)}
				{isLoading && isPagePayment ? (
					<LoaderBar width={80} />
				) : (
					<AmountContainer amount={total} />
				)}
			</div>
		</div>
	);
};

Total.propTypes = {
	total: PropTypes.number,
	discountPercentage: PropTypes.number,
	isPagePayment: PropTypes.bool,
	isLoading: PropTypes.bool,
	taxesAndFeesIncluded: PropTypes.bool,
};

export default memo(Total);
